/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:48:59
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-11 16:59:33
 * @Description: 静态地址
 */

import { Config } from '@/config';

export const STATIC_URL = {
    login: `https://${Config.envUrl}s.theckb.com/login`,
    SelectIdentity: '/smc/promotion/SelectIdentity'
};

if (Config.env === 'dev') {
    STATIC_URL.login = `http://${window.location.host}/smc/dev/login`;
}

/** 缓存当前用户的站点。如果用户退出刷新获取上次的值 */
export const CACHE_STATION_NAME = 'smc-stationCode';
